import { createFileRoute } from "@tanstack/react-router";
import Faq from "@/pages/Faq";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/faq/")({
  head: () => routeHead("/de/faq/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Faq />
  );
}
